import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { selectCurrency } from "../store/purchasesSelectors";
import { setCurrency } from "../store/purchasesSlice";
import { CurrencyE } from "../models/enums";
import useCurrentCurrency from "../../Plans/Utils/useCurrentCurrency";

/**
 * Custom hook for managing currency state.
 * Returns the current currency and a function to change the currency.
 *
 * @returns An object containing the current currency and a function to change the currency.
 */
const useCurrency = () => {
  const dispatch = useAppDispatch();
  const currentUserCurrency = useCurrentCurrency();

  const currency = useAppSelector(selectCurrency);

  const changeCurrency = useCallback(() => {
    dispatch(setCurrency(currentUserCurrency as CurrencyE));
  }, [currentUserCurrency]);

  return {
    currency: (currency as string) === "NIS" ? CurrencyE.ILS : currency,
    setCurrency: changeCurrency,
  };
};

export default useCurrency;
